import { memo } from 'react'

import App from './App'

const AppComponent = memo(App)
export default AppComponent
